import React, { useState, useEffect, useContext, useMemo } from "react";
import { Box, Button, ClickAwayListener, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Select, TextField } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import TableAllData from "components/Content/CustomTable/TableAllData";

import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Utils } from 'common/Utils';
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

export default function EmailAttachments({isEditable, templateId, refresh, handlePromptDeleteAttachment, updateAttachmentCount}) {
    const { companyId, error } = useContext(PrivateRoutesContext);
    const [attachments, setAttachments] = useState([]);
    const [downloadingEmailFileId, setDownloadingEmailFileId] = useState('');


    useEffect(() => {
        loadAttachments();
    },[templateId, refresh]);

    useEffect(() => {
        if (updateAttachmentCount) {
            updateAttachmentCount(attachments.length);
        }
    },[attachments]);

    const columns = useMemo(() => {
        let cols = [
            {
                id: "externalEmailFileId",
                accessor: (cell) => (
                    <>
                        <LoadingButton 
                            onClick={() => handleDownloadAttachment(cell)}
                            loading={downloadingEmailFileId === cell.externalEmailFileId}
                            loadingPosition="start"
                            startIcon={<CloudDownloadOutlinedIcon />}
                            disabled={downloadingEmailFileId !== ''}
                        >
                        </LoadingButton>
                        {isEditable ?
                            <IconButton
                                color="primary"
                                onClick={(e) => handlePromptDeleteAttachment(cell, e)}
                            >
                                <DeleteOutlineOutlinedIcon />
                            </IconButton>
                        : null}
                    </>
                ),
                disableFilters: true,
            },
            {
                Header: "File Name",
                accessor: "fileName",
            },
            {
                Header: "Update Date",
                accessor: (cell) => Utils.formatDate(cell.updateDate),
                Cell: ({row}) => (
                  <Box>
                    {Utils.formatDate(row.original.updateDate)}
                  </Box>
                ),
                sortType: "dateSort",
            },
            {
                Header: "Update By",
                accessor: (cell) => `${cell.updateUser}`,
            },
        ];

        return cols;
    });

    const loadAttachments = () => {
        if (templateId == Utils.emptyGuid()) {
            setAttachments([]);
        }
        else {
            apiGet(apiUrls.getEmailAttachments(companyId, templateId)).then((response) => {
                setAttachments(response.data);
            }).catch((response) => {
                error.setTitle("An Error Occurred");
                error.setText("An Error occurred loading email attachments.");
                error.setDoShowError(true);
            });
        }
    }

    const handleDownloadAttachment = (attachment) => {
        setDownloadingEmailFileId(attachment.externalEmailFileId);
        Utils.downloadFile(apiUrls.downloadEmailAttachments(attachment.externalEmailFileId), attachment.fileName, 
          () => {
              setDownloadingEmailFileId('');
          }
        , 
          () => {
            error.setTitle("An Error Occurred");
            error.setText("An Error occurred downloading the file.");
            error.setDoShowError(true);
          });
      }

    return (<TableAllData columns={columns} data={attachments} />)
}